// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".datepicker-holder[data-v-0ba41b2b] {\n  position: relative;\n  top: -24px;\n  left: 25px;\n  width: 90%;\n}\n", ""]);
// Exports
module.exports = exports;
